module.exports = __webpack_public_path__ + "img/bell-alert.d2c9c6a6.svg";